import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

export const IS_POSTCODE_BLOCKING_SUBMISSION = gql`
  query IsPostcodeBlockingSubmission(
    $postcode: String!
    $sectorName: String!
    $subcategoryCountryCode: String!
  ) {
    isPostcodeBlockingSubmission(
      postcode: $postcode
      sectorName: $sectorName
      subcategoryCountryCode: $subcategoryCountryCode
    ) {
      isBlockingSubmission
    }
  }
`;

const isPostcodeBlockingSubmissionQuery = async ({
  postcode,
  sectorName,
  subcategoryCountryCode,
}) => {
  try {
    const { data } = await query({
      query: IS_POSTCODE_BLOCKING_SUBMISSION,
      variables: {
        postcode,
        sectorName,
        subcategoryCountryCode,
      },
    });
    return data.isPostcodeBlockingSubmission.isBlockingSubmission;
  } catch (error) {
    throw new Error(
      'Failed to determine if zip code is blocking submission',
      error
    );
  }
};

export default isPostcodeBlockingSubmissionQuery;
